import { auth, type SchemaResponse } from "@/modules/api/axios"

export type ScreenViewPlatform = "IOS" | "ANDROID" | "WEB"

export type TrackScreenViewPayload = {
  screen: string
  deviceId: string
  platform: ScreenViewPlatform
  appVersion?: string
}

export type TrackScreenViewResult = {
  tracked: boolean
  counted: boolean
  screen: string
}

// `auth` attaches the token when present and refreshes + retries on 401, so a
// logged-in KOC is never recorded under the anonymous deviceId.
export const trackScreenView = (payload: TrackScreenViewPayload) =>
  auth.post<SchemaResponse<TrackScreenViewResult>>("koc-app-analytics/screen-views", payload)
